import React from 'react'
import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineKeySkeletonIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="m21 4.41.71-.7a1.0041 1.0041 0 1 0-1.42-1.42l-1.4 1.41-2.83 2.83-6.31 6.3a5 5 0 1 0 1.42 1.42l5.59-5.6 2.12 2.13a1.0012 1.0012 0 0 0 .7085.2906A1.0004 1.0004 0 0 0 20.29 9.36l-2.12-2.12 1.42-1.41.7.7a1.0007 1.0007 0 0 0 1.633-.3188.9996.9996 0 0 0 .0027-.7658.9993.9993 0 0 0-.2157-.3254L21 4.41ZM7 20a2.9996 2.9996 0 0 1-2.7717-1.8519 3.0001 3.0001 0 0 1 3.9197-3.9197A3 3 0 0 1 7 20Z"/>
  </SvgIcon>
}

export default LineKeySkeletonIcon
